import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class DocumentFolder extends DomainObject {
  @observable id;
  @observable name;
  @observable order;
  @observable parentId;
  @observable hasSubfolders;
  @observable subfolders = [];
}

export default DocumentFolder;

